import type {ParamValueItemBody} from './ParamValueItemBody';

export type StructureItemBody = {
  categoryId?: string | null;
  paramDefinitionId?: string | null;
  visible: boolean;
  mandatory: boolean;
  paramValues?: Array<ParamValueItemBody>;
};
